const Navigation = ({ scrolled }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`nav-header ${scrolled ? 'scrolled' : ''}`} data-testid="navigation-header">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <button
          onClick={() => scrollToSection('hero')}
          className="nav-link"
          data-testid="nav-logo">
          Interlude
        </button>
        
        <div className="hidden md:flex items-center gap-10">
          <button onClick={() => scrollToSection('story')} className="nav-link" data-testid="nav-story">
            About
          </button>
          <button onClick={() => scrollToSection('collection')} className="nav-link" data-testid="nav-collection">
            Fragrances
          </button>
          <button onClick={() => scrollToSection('partnership')} className="nav-link" data-testid="nav-partnership">
            Partner With Us
          </button>
        </div>

        <button
          className="btn-primary text-xs px-6 py-3"
          data-testid="nav-contact-btn"
          onClick={() => scrollToSection('partnership')}>
          Get in Touch
        </button>
      </nav>
    </header>
  );
};

export default Navigation;
